module.exports = __webpack_public_path__ + "static/media/background_1080px_WEBP.fa0d1aef.webp";